import type { FC } from 'react';
import React from 'react';
import cn from 'classnames';

import type { TCard } from './models';

export const PromoCardV2: FC<React.PropsWithChildren<TCard>> = ({
    Block,
    DataLayer,
    analyticsClick,
    autoHeight = false,
    background,
    backgroundColor,
    backgroundPosition,
    backgroundSize,
    children,
    dataTestId,
    defaultHeight,
    defaultWidth,
    height,
    hoverEffect = true,
    id,
    styles,
    type,
    padding = type === 'mobile' ? 16 : 32,
    borderRadius = type === 'mobile' ? 24 : 8,
    useNamedContainers,
    width,
}) => {
    const { buttons, content, title } = useNamedContainers(children);

    return (
        <DataLayer data={analyticsClick} tag={null}>
            <Block
                className={cn(styles.card, styles.external, {
                    [styles.active]: hoverEffect,
                    [styles.cardMinHeight]: !autoHeight,
                })}
                dataTestId={dataTestId}
                fullHeight={!autoHeight}
                id={id?.toString()}
                notPadded
                style={{
                    backgroundImage: background ? `url(${background}) ` : undefined,
                    backgroundColor,
                    backgroundPosition,
                    backgroundSize,
                    width: width ?? defaultWidth,
                    height: autoHeight ? undefined : height ?? defaultHeight,
                }}
                styler={{ padding, borderRadius }}
            >
                <div className={styles.content}>
                    <div>
                        {title}
                        {content}
                    </div>
                    <div className={styles.buttonContainer}>{buttons}</div>
                </div>
            </Block>
        </DataLayer>
    );
};
